<ds-listable-object-component-loader [object]="metadataRepresentation"
                                     [viewMode]="viewMode"></ds-listable-object-component-loader>
